import { render, staticRenderFns } from "./TabTimelineProtocol.vue?vue&type=template&id=747c4886&scoped=true&"
import script from "./TabTimelineProtocol.vue?vue&type=script&lang=js&"
export * from "./TabTimelineProtocol.vue?vue&type=script&lang=js&"
import style0 from "./TabTimelineProtocol.vue?vue&type=style&index=0&id=747c4886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c4886",
  null
  
)

export default component.exports